// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__wPrjX","landingHeader":"styles_landingHeader__A5jia","landingBody":"styles_landingBody__h1cK-"};